<template>
  <JyPagebody :activatedLoad="getData" :style="{'background-color': backgroundColor}" class="template-edit" :class="['align-'+ editAlign]">
    <div class="template-edit-container">
      <div v-if="!$scopedSlots.header" class="form-header d-flex">
        <h4 class="flex-grow-1 mb-0 text-center">{{ editTitle }}</h4>
        <div v-show="!isSm" class="ml-auto">
          <el-radio-group v-model="editAlign" size="mini">
            <el-radio-button label="left" title="靠左"><i class="fa fa-align-left"></i></el-radio-button>
            <el-radio-button label="center" title="居中"><i class="fa fa-align-center"></i></el-radio-button>
            <el-radio-button label="right" title="靠右"><i class="fa fa-align-right"></i></el-radio-button>
            <el-radio-button label="justify" title="充满"><i class="fa fa-align-justify"></i></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <slot name="header"></slot>
      <div class="form-body">
        <slot></slot>
      </div>
    </div>
    <div v-if="$scopedSlots.footer" slot="footer" class="form-footer">
      <slot name="footer"></slot>
    </div>
  </JyPagebody>
</template>
<script>
import { mapGetters } from 'vuex';
import JyPagebody from 'jycomponents/page/body';
import tools from 'jyutils/tools';
export default {
  components: { JyPagebody },
  mixins: [tools],
  props: {
    editTitle: String,
    getData: Function,
    rules: {
      type: Object,
      default: () => {
        return {};
      }
    },
    formAlign: String,
    backgroundColor: {
      type: String,
      default: '#eaedf1'
    },
  },
  data() {
    return {
      editAlign: 'left'
    }
  },
  computed: {
    ...mapGetters({
      'settings': 'settings'
    }),
  },
  watch: {
    editAlign(val) {
      this.$store.commit('setEditAlign', val);
    }
  },
  beforeRouteLeave (to, from, next) {
    this.confirmSave(
      `未保存编辑内容，离开可能会丢失数据，确定要离开吗？`,
      next,
      () => {
        next(false);
      }
    );
  },
  mounted() {
    this.editAlign = this.formAlign || this.settings.editAlign || 'left';
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.template-edit {
  align-items:center;
  &.align-left {
    align-items:flex-start;
  }
  &.align-right {
    align-items:flex-end;
  }
  &.align-justify {
    /deep/ .footer,
    .template-edit-container {
      max-width:100%;
      flex-grow:1;
    }
  }
  /deep/ .footer {
    width:100%;
    max-width:1000px;
  }
  &-container {
    .flex();
    flex-direction:column;
    justify-self:center;
    width:100%;
    height:100%;
    max-width:1000px;
    overflow:hidden;
    .bg-white(1);
    .form-header, .form-footer {
      padding:1rem;
      flex-shrink:0;
    }
    .form-header {
      padding:1rem;
      background-color:#f9fafc;
      border-bottom:1px #f5f5f5 solid;
    }
    .form-body {
      padding:1rem .5rem 1rem 1rem;
      flex-grow:1;
      overflow-y:auto;
    }
    .form-footer {
      padding:.5rem 1rem;
      text-align:center;
      background-color:#f9fafc;
      border-top:1px #f5f5f5 solid;
    }
  }
}
</style>